import { Navigate, useParams } from 'react-router-dom';

import { AppMerchandisingPage } from '~/components/pages/AppMerchandisingPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';

export const AppMerchandisingRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppMerchandisingPage appId={appId} />
    </DashboardTemplate>
  );
};
